// import { CHECKOUT_STEPS_NAMES } from "../../../shared";

import { CHECKOUT_STEPS_NAMES } from "app/shared/name/name.library";

export const continueButton = (
	valid: boolean,
	step: string
): {
	enabled: boolean;
	busy: boolean;
	text: string;
} => {
	let enabled = true;
	const busy = false;
	let text = "CONTINUE";
	if (step === CHECKOUT_STEPS_NAMES.aboutYou) {
		enabled = valid;
	}
	if (step === CHECKOUT_STEPS_NAMES.paymentDetails) {
		enabled = valid;
		text = 'CONFIRM & PAY'
	}
	if (step === CHECKOUT_STEPS_NAMES.setup) {
		enabled = valid;
	}
	if (step === CHECKOUT_STEPS_NAMES.proofOfId) {
		enabled = valid;
		text = "VERIFY DETAILS";
	}

	return {
		enabled,
		busy,
		text,
	};
};
